import { createSlice } from '@reduxjs/toolkit';
import { resolveAcceptedDocuments } from '../../library/accepted-documents';

const initialState = {
  clientIpAddress: '',
  isAccountContactsVerificationRequired: false,
  isRegistrationContactsVerificationRequired: false,
  isRegistrationEmailOtpRequired: false,
  isRegistrationPhoneOtpRequired: false,
  isSignicatOnfidoEnabled: false,
  payoutChannelCodeWithValidation: [],
  payoutChannelCodePhoneNumberAsAccountNumber: [],
  minimumSendingLimits: [],
  methodAmountCurrencyLimitSwitches: [],
  configuration: {},
  acceptedDocuments: null,
  recipientConfiguration: {},
  promoCodeConfig: {},
  testConfiguration: {},
  transactionsInCompliancePending: false,
  transactionsInComplianceHold: false,
  complianceEDDRequests: [],
  complianceEDDRequested: false,
  isPinRequired: false,
  isOtpRequired: false,
  isMobile: false,
  themeVariant: 'default',
  notificationOpen: false,
  notificationSeverity: 'info',
  notificationMessage: '',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setClientIpAddress(state, action) {
      state.clientIpAddress = action.payload;
    },
    setClientConfig(state, action) {
      const {
        contactsVerification,
        signicat,
        payout,
        minimumSendingLimits,
        methodAmountCurrencyLimitSwitches,
        configuration,
        recipient,
        testConfiguration,
        promoCode,
        documentUpload,
      } = action.payload;
      const { isAccountRequired, isRegistrationRequired, isEmailOtpRequired, isPhoneOtpRequired } = contactsVerification;
      const { isOnfidoEnabled } = signicat;
      const { channelsWithValidation, channelsPhoneNumberAsAccountNumber } = payout ?? {};
      state.isAccountContactsVerificationRequired = isAccountRequired;
      state.isRegistrationContactsVerificationRequired = isRegistrationRequired;
      state.isRegistrationEmailOtpRequired = isEmailOtpRequired;
      state.isRegistrationPhoneOtpRequired = isPhoneOtpRequired;
      state.isSignicatOnfidoEnabled = isOnfidoEnabled;
      state.payoutChannelCodeWithValidation = channelsWithValidation ? channelsWithValidation.map((channel) => channel.toString()) : [];
      state.payoutChannelCodePhoneNumberAsAccountNumber = channelsPhoneNumberAsAccountNumber
        ? channelsPhoneNumberAsAccountNumber.map((channel) => channel.toString())
        : [];
      state.minimumSendingLimits = minimumSendingLimits ?? [];
      state.methodAmountCurrencyLimitSwitches = methodAmountCurrencyLimitSwitches ?? [];
      state.recipientConfiguration = recipient ?? {};
      state.configuration = configuration ?? {};
      state.acceptedDocuments = resolveAcceptedDocuments(documentUpload?.acceptedDocuments);
      state.promoCodeConfig = promoCode ?? {};
      state.testConfiguration = testConfiguration ?? {};
    },
    setTransactionsInCompliancePending(state, action) {
      state.transactionsInCompliancePending = action.payload;
      // state.error = false;
      // state.errorMessage = '';
      // state.loading = false;
    },
    setTransactionsInComplianceHold(state, action) {
      state.transactionsInComplianceHold = action.payload;
      // state.error = false;
      // state.errorMessage = '';
      // state.loading = false;
    },
    setComplianceEDDRequests(state, action) {
      state.complianceEDDRequests = action.payload;
      state.complianceEDDRequested = !!action.payload && !!action.payload.length;
    },
    setIsPinRequired(state, action) {
      state.isPinRequired = action.payload;
    },
    setIsOtpRequired(state, action) {
      state.isOtpRequired = action.payload;
    },
    setIsMobile(state, action) {
      state.isMobile = action.payload;
    },
    setThemeVariant(state, action) {
      state.themeVariant = action.payload || 'default';
    },
    setNotification(state, action) {
      const { notificationMessage, notificationSeverity } = action.payload;

      state.notificationOpen = true;
      state.notificationSeverity = notificationSeverity;
      state.notificationMessage = notificationMessage;
    },
    resetNotification(state, action) {
      state.notificationOpen = false;
      state.notificationSeverity = 'info';
      state.notificationMessage = '';
    },
    setError(state, action) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
    },
    clearError(state, action) {
      state.error = action.payload;
      state.errorMessage = '';
    },
    logout: (state) => initialState,
  },
});

export const appActions = appSlice.actions;
export default appSlice;
